import { render, staticRenderFns } from "./tabla_usuarios.vue?vue&type=template&id=4c625ac0&"
import script from "./tabla_usuarios.vue?vue&type=script&lang=js&"
export * from "./tabla_usuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports